import type { CropMonitoring } from '/@/types/crop-monitoring';

type Crop = CropMonitoring['crop'];

/** FieldView's free-text crop names we can monitor (mirrors the backend's `fieldview_crop`). */
const FIELDVIEW_CROPS: Record<string, Crop> = {
    corn: 'corn',
    maize: 'corn',
    soy: 'soy',
    soybean: 'soy',
    soybeans: 'soy',
    wheat: 'wheat',
    barley: 'barley',
};

/** The crop of a FieldView crop name: wheat varieties (`Wheat, Durum`) are wheat and any corn
 * (`Popcorn, White`, `Silage Corn`) is corn. Undefined for crops we don't monitor. */
export const fieldviewCrop = (cropName: string): Crop | undefined => {
    const name = (cropName ?? '').trim().toLowerCase();
    if (name in FIELDVIEW_CROPS) return FIELDVIEW_CROPS[name];
    if (name.split(',')[0]?.trim() === 'wheat') return 'wheat';
    if (name.includes('corn') || name.includes('maize')) return 'corn';
    return undefined;
};

/** Whether a FieldView harvest of `cropName` can be a crop monitoring of `crop`'s harvest. */
export const matchesCrop = (cropName: string, crop: Crop): boolean => fieldviewCrop(cropName) === crop;
